/**
 * @param {{onResolve: () => void}} callbacks
 * @returns {{getState: ()=> {state: "available", hints: {}} | {state: "unavailable"} | {state: "loading"}}}
 */
export function ClientHintsProvider(callbacks) {
  /**
   * @type {("loading" | "available" | "unavailable")}
   */
  let state = 'loading';
  let clientHints = undefined;

  if (!navigator.userAgentData?.getHighEntropyValues) {
    state = 'unavailable';
  } else {
    navigator.userAgentData
      .getHighEntropyValues(['model', 'brands', 'platform', 'platformVersion', 'fullVersionList'])
      .then((data) => {
        clientHints = data;
        state = 'available';
      })
      .catch(() => {
        state = 'unavailable';
      })
      .finally(() => {
        callbacks.onResolve();
      });
  }

  return {
    getState: () => {
      if (state === 'available') {
        return {
          state: 'available',
          hints: clientHints,
        };
      }

      return {
        state,
      };
    },
  };
}
